import { Component, Element, Prop, h } from '@stencil/core';

@Component({
  tag: 'vs-slide',
  styleUrl: 'vs-slide.css',
  shadow: false,
})
export class VsSlide {
  @Prop() data: any;
  @Prop() type: string;
  @Prop() slideCount: number;
  @Prop() onSlideSwipe: (event: CustomEvent) => void;
  @Element() hostElement: HTMLVsSlideElement;

  @Prop() accessibility?: any;
  render() {
    return (
      <div>
        {this.type === 'marquee' ? <visa-marquee
          enabled={true}
          marqueeID={this.data.id}
          slideLength={this.slideCount}
          teaserTheme={this.data.teaser.themeVariant}
          teaserAlignment={this.data.alignment}
          teaserEyebrowText={this.data.teaser.eyebrowText}
          teaserHeadline={this.data.teaser.headline}
          teaserSubHeadline={this.data.teaser.subHeadline}
          headingStyle={this.data.teaser.headingStyle}
          hasTransparentTeaser={this.data.teaser.transparent === "yes" ? true : false}
          mobileImage={this.data.image.mobileImagePath}
          mobileImageAlt={this.data.image.mobileImageAltText}
          desktopImage={this.data.image.desktopImagePath}
          desktopImageAlt={this.data.image.desktopImageAltText}
          videoEnabled={this.data.videoEnabled === "yes" ? true : false}
          videoProps={this.data.video}
          linkStyle={this.data.teaser.ctaLink.ctaType}
          linkType={this.data.teaser.ctaLink.linkType}
          linkText={this.data.teaser.ctaLink.text}
          linkVal={this.data.teaser.ctaLink.link}
          linkTarget={this.data.teaser.ctaLink.target}
          linkConversion={this.data.teaser.ctaLink.conversionType}
          linkVideoImage={this.data.teaser.ctaLink.videoImage}
          linkVideoTitle={this.data.teaser.ctaLink.videoTitle}
          linkVideoImageText={this.data.teaser.ctaLink.videoImageText}
          linkVideoLink={this.data.teaser.ctaLink.videoLink}
          linkVideoAriaLabel={this.data.teaser.ctaLink.linkAriaLabel}
          linkNoFollow={this.data.teaser.ctaLink.ctaNoFollow}
          linkAriaLabel={this.data.teaser.ctaLink.linkAriaLabel}
          linkPropColor={this.data.teaser.ctaLink.ctaButtonColor}
          linkStyleSub={this.data.teaser.ctaLink1.ctaType}
          linkTypeSub={this.data.teaser.ctaLink1.linkType}
          linkTextSub={this.data.teaser.ctaLink1.text}
          linkValSub={this.data.teaser.ctaLink1.link}
          linkTargetSub={this.data.teaser.ctaLink1.target}
          linkConversionSub={this.data.teaser.ctaLink1.conversionType}
          linkAriaLabelSub={this.data.teaser.ctaLink1.linkAriaLabel}
          linkVideoImageSub={this.data.teaser.ctaLink1.videoImage}
          linkVideoTitleSub={this.data.teaser.ctaLink1.videoTitle}
          linkVideoImageTextSub={this.data.teaser.ctaLink1.videoImageText}
          linkVideoLinkSub={this.data.teaser.ctaLink1.videoLink}
          linkVideoAriaLabelSub={this.data.teaser.ctaLink1.linkAriaLabel}
          linkNoFollowSub={this.data.teaser.ctaLink1.ctaNoFollow}
          accessibility={this.accessibility}
        >
        </visa-marquee> : this.type === 'quote' ? (
            <vs-quote
              quoteText={this.data.quoteText}
              backgroundColor={this.data.backgroundColor}
              quoteTextStyle={this.data.quoteTextStyle}
              showQuoteMark={this.data.showQuoteMark}
              attrTitle={this.data.quoteTitle}
              attrImagePath={this.data.quoteMediaImagePath}
              attrImageAltText={this.data.quoteImageAltText}
              attrLogoImagePath={this.data.quoteLogoImagePath}
              attrLogoImageAltText={this.data.quoteLogoImageAltText}
              cta={this.data.ctaJson?.[0]}
              removeBottomMargin={this.data.bottomMargin === 'false' ? true : false}
            >
            </vs-quote>
          )
        :
          <visa-submarquee
            enabled={true}
            marqueeID={this.data.id}
            teaserTheme={this.data.teaser.themeVariant}
            teaserAlignment={this.data.alignment}
            teaserEyebrowText={this.data.teaser.eyebrowText}
            teaserHeadline={this.data.teaser.headline}
            teaserSubHeadline={this.data.teaser.subHeadline}
            headingStyle={this.data.teaser.headingStyle}
            hasTransparentTeaser={this.data.teaser.transparent === "yes" ? true : false}
            mobileImage={this.data.image.desktopImagePath}
            mobileImageAlt={this.data.image.desktopImageAltText}
            desktopImage={this.data.image.desktopImagePath}
            desktopImageAlt={this.data.image.desktopImageAltText}
            videoEnabled={this.data.videoEnabled === "yes" ? true : false}
            videoProps={this.data.video}
            linkStyle={this.data.teaser.ctaLink.ctaType}
            linkType={this.data.teaser.ctaLink.linkType}
            linkText={this.data.teaser.ctaLink.text}
            linkVal={this.data.teaser.ctaLink.link}
            linkTarget={this.data.teaser.ctaLink.target}
            linkConversion={this.data.teaser.ctaLink.conversionType}
            linkVideoImage={this.data.teaser.ctaLink.videoImage}
            linkVideoTitle={this.data.teaser.ctaLink.videoTitle}
            linkVideoImageText={this.data.teaser.ctaLink.videoImageText}
            linkVideoLink={this.data.teaser.ctaLink.videoLink}
            linkVideoAriaLabel={this.data.teaser.ctaLink.linkAriaLabel}
            linkNoFollow={this.data.teaser.ctaLink.ctaNoFollow}
            linkAriaLabel={this.data.teaser.ctaLink.linkAriaLabel}
            linkPropColor={this.data.teaser.ctaLink.ctaButtonColor}
            linkStyleSub={this.data.teaser.ctaLink1.ctaType}
            linkTypeSub={this.data.teaser.ctaLink1.linkType}
            linkTextSub={this.data.teaser.ctaLink1.text}
            linkValSub={this.data.teaser.ctaLink1.link}
            linkTargetSub={this.data.teaser.ctaLink1.target}
            linkConversionSub={this.data.teaser.ctaLink1.conversionType}
            linkAriaLabelSub={this.data.teaser.ctaLink1.linkAriaLabel}
            linkVideoImageSub={this.data.teaser.ctaLink1.videoImage}
            linkVideoTitleSub={this.data.teaser.ctaLink1.videoTitle}
            linkVideoImageTextSub={this.data.teaser.ctaLink1.videoImageText}
            linkVideoLinkSub={this.data.teaser.ctaLink1.videoLink}
            linkVideoAriaLabelSub={this.data.teaser.ctaLink1.linkAriaLabel}
            linkNoFollowSub={this.data.teaser.ctaLink1.ctaNoFollow}
            accessibility={this.accessibility}
          >
          </visa-submarquee>}
      </div>
    );
  }

}
